import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './global.less'
import './permission.js'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import store from './store/'
import i18n from './locales'
import { HttpHandlerService } from '@/core/http-handler-service'

Vue.config.productionTip = false

Vue.use(Antd)
Vue.prototype.$HttpHandlerService = new HttpHandlerService()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
